"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enableLogger = exports["default"] = void 0;

var _reduxLogger = require("redux-logger");

var options = {
  collapsed: true
};

var _default = (0, _reduxLogger.createLogger)(options);

exports["default"] = _default;

var enableLogger = function enableLogger(config) {
  // check for debug mode
  return !process.env.isProd && config.reduxLogger || window.location.search.indexOf('debug') !== -1;
};

exports.enableLogger = enableLogger;